import {
  Component,
  OnDestroy,
  OnInit,
  AfterViewChecked,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NavigationEvent } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';
import { GeneralService } from '../../services/general/general.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import timezones from 'src/assets/data/timezones/index';
import { Capacitor } from '@capacitor/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('content') elementView: ElementRef | undefined;
  @Output() height = new EventEmitter<Number>();
  @Input() sideNav: any = null;
  subheader: any = null;

  public lang: string = 'es';
  public langs: any = ['es', 'en', 'ru'];
  public subscriptions: any = [];
  public isMobile: any = false;

  public user: any;
  public userInfo: any;

  public wallet: any = '... €';
  public isTeacher: any = false;
  public timezones = new Array();
  public timezoneCtrl = new FormControl();
  public noReadMessages = 0;
  public currency: any;

  public ios: boolean | undefined;

  public logoLinkInternal: any;
  public logoLinkExternal: any;

  constructor(
    public general: GeneralService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (Capacitor.getPlatform() === 'ios') {
      this.ios = true;
    }else{
      this.ios = false;
    }

    this.lang = this.general.translate.currentLang;
    this.isMobile = this.general.isMobile();
    this.initTimeZones();
  }

openWordiix(){
    window.open("https://app.wordiix.com/", '_self');
  }
  async ngOnInit() {
    
    let token = localStorage.getItem('access_token');

    if (typeof token === 'string') {

      await this.getUserInfo();

      await this.intializeSubscriptions();
      
      if (this.user) {
        this.isTeacher = this.user.rol === 'teacher';
        if (this.isTeacher) {
          this.subheader = 'teacher';
        } else {
          this.subheader = 'student';
        }
      }

      setInterval(() => {
        let noReadChatsRemporal: any = '0';
        noReadChatsRemporal = localStorage.getItem('noReadChats');
        this.noReadMessages = parseInt(noReadChatsRemporal);
      }, 100);
      
    }
    if (this.user?.rol === 'teacher') {
      this.logoLinkInternal = "/teacher/dashboard";
      this.loadTeacherInitData();
    } else if (this.user?.rol === 'student') {
      this.logoLinkInternal = "/student/dashboard";
      this.loadStudentInitData();
    }else{
      this.logoLinkExternal = "https://wordiix.com";
    }

    window.addEventListener('set-lang', this);
    window.addEventListener('user:update-timezone', this);

    if(!localStorage.getItem("currency")){
      localStorage.setItem('currency', "eur");
    }
    this.currency = localStorage.getItem("currency");
  
  }

  
  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  
  

  // Handle event Listener
  async handleEvent(event: any) {
    switch (event.type) {
      case 'user:update-timezone':
        await this.general.sleep(100);
        const timezone = localStorage.getItem('timezone');
        this.timezoneCtrl.patchValue(timezone);
        break;
      case 'set-lang':
        this.lang = event.detail;
        break;
    }
  }

  async ngOnDestroy() {
    window.removeEventListener('set-lang', this);
    window.removeEventListener('user:update-timezone', this);

    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  /**
   * =================== Functions ===================
   */
  intializeSubscriptions() {
    this.subscriptions = [
      this.general.noReadMessages$.subscribe(async (data: any) => {
        this.noReadMessages = data;
      }),

      this.general.wallet$.subscribe(async (data: any) => {
        this.wallet = data;
      }),
    ];
  }

  async onChangeLang(event: any, reload = true) {
    this.general.translate.use(event);
    localStorage.setItem('lang', event);
    this.setLocale(event);
    if (reload) {
      let params: any = await this.general.getQueryParams();
      if (params.lang) {
        let body = { ...params };
        body.lang = null;
        this.general.updateQueryParams(body);
      }
      window.location.reload();
    }
    if (this.user) {
      await this.general.httpPost('update-language', {
        default_lang: event,
      });
    }
  }

  async onUserChangeTimeZone(timezone: any) {
    localStorage.setItem('timezone', timezone);

    if (this.user) {
      await this.general.httpPost('user-update-timezone', {
        timezone,
      });
    }

    location.reload();
  }

  ngAfterViewChecked() {
    this.height.emit(this.elementView?.nativeElement.offsetHeight);
  }

  goToProfile() {
    if (!this.user) {
      this.general.navigate('auth/login');
    } else if (this.user.rol === 'teacher') {
      this.general.navigate('/teacher/dashboard');
    } else {
      this.general.navigate('/student/dashboard');
    }
  }

  goToWallet() {
    if (!this.user) {
      this.general.navigate('auth/login');
    } else if (this.user.rol === 'teacher') {
      this.general.navigate('/teacher/wallet');
    } else {
      this.general.navigate('/student/settings/wallet');
    }
  }

  goToPremium() {
    this.general.navigate('/premium');
  }

  async logout() {
    try {
      localStorage.clear();
      await this.general.navigate('/auth/login');
    } catch (error: any) {
      await this.general.showDanger(error.message);
    }
  }

  initTimeZones() {
    this.timezones = timezones.map((timezone) => {
      return { label: timezone.label, value: timezone.tzCode };
    });

    let timezone: any = this.general.getCurrentTimezone();

    this.timezoneCtrl.patchValue(timezone);
  }

  get checkShowGoPremium() {

    if (this.user?.is_premium && this.isTeacher) {
      return false;
    } else if (!this.user?.is_premium && this.isTeacher) {
      return true;
    } else {
      return false;
    }
  }

  setLocale(lang: string) {
    switch (lang) {
      case 'es':
        localStorage.setItem('locale', 'es-es');
        break;
      case 'en':
        localStorage.setItem('locale', 'en-gb');
        break;
      case 'ru':
        localStorage.setItem('locale', 'ru');
        break;
    }
  }
  currencyChange(curr:any){
    if(curr.target){
      curr = curr.target.value;
    }else{
      curr = curr.value;
    }
    localStorage.setItem('currency', curr);
    let event = new Event('currency_change');
    window.dispatchEvent(event);
  }

  async loadStudentInitData() {
    const requests = [this.general.httpGet('student-hours')];
    const response: any = await this.general.forkJoin(requests);
    this.setWalletStudent(response[0].data);
  }

  async setWalletStudent(data: any) {
    const hours = await this.general.getTranslations('hours');
    this.general.setWallet(`${data} ${hours}`);
  }
  async setWalletTeacher(data: any) {
    this.general.setWallet(`${data} €`);
  }

  async loadTeacherInitData() {
    const requests = [this.general.httpGet('wallet-available')];
    const response: any = await this.general.forkJoin(requests);
    this.setWalletTeacher(response[0].data);
  }
  
}
